module.exports = __webpack_public_path__ + "static/media/map-bg.9d04a702.jpg";